import { Routes } from '@angular/router';
import { LoginComponent } from './views/auth/login/login.component';
import { AdminLayoutComponent } from './views/layout/admin-layout/admin-layout.component';
import { DashboardComponent } from './views/pages/dashboard/dashboard.component';
import { adminAuthGuard } from './core/guards/admin-auth.guard';

export const routes: Routes = [
  // Login (público)
  {
    path: 'login',
    component: LoginComponent
  },
  
  // Rutas protegidas con layout
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [adminAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'metrics',
        loadComponent: () => import('./views/pages/saas/saas-metrics/saas-metrics.component').then(m => m.SaasMetricsComponent)
      },
      {
        path: 'customers',
        loadComponent: () => import('./views/pages/saas/saas-customers/saas-customers.component').then(m => m.SaasCustomersComponent)
      },
      {
        path: 'subscriptions',
        loadComponent: () => import('./views/pages/saas/subscriptions/subscriptions.component').then(m => m.SubscriptionsComponent)
      },
      {
        path: 'activations',
        loadComponent: () => import('./views/pages/saas/activations/activations.component').then(m => m.ActivationsComponent)
      },
      {
        path: 'upgrades',
        loadComponent: () => import('./views/pages/saas/upgrades-addons/upgrades-addons.component').then(m => m.UpgradesAddonsComponent)
      },
      {
        path: 'coupons',
        loadComponent: () => import('./views/pages/saas/coupons-referrals/coupons-referrals.component').then(m => m.CouponsReferralsComponent)
      },
      {
        path: 'commissions',
        loadComponent: () => import('./views/pages/saas/saas-commissions/saas-commissions.component').then(m => m.SaasCommissionsComponent)
      },
      {
        path: 'catalog',
        loadComponent: () => import('./views/pages/saas/product-catalog/product-catalog.component').then(m => m.ProductCatalogComponent)
      },
      {
        path: 'plans',
        loadComponent: () => import('./views/pages/saas/plans-pricing/plans-pricing.component').then(m => m.PlansPricingComponent)
      },
      {
        path: 'modular-rules',
        loadComponent: () => import('./views/pages/saas/modular-rules/modular-rules.component').then(m => m.ModularRulesComponent)
      },
      {
        path: 'payments',
        loadComponent: () => import('./views/pages/saas/payments/payments.component').then(m => m.SaasPaymentsComponent)
      },
      {
        path: 'billing-cycles',
        loadComponent: () => import('./views/pages/saas/recurring-billing/recurring-billing.component').then(m => m.RecurringBillingComponent)
      },
      {
        path: 'overdue',
        loadComponent: () => import('./views/pages/saas/overdue-management/overdue-management.component').then(m => m.OverdueManagementComponent)
      },

      // ── Tickets y Soporte (mesa de ayuda de ATS) ──────────────────────────
      // OJO: es el soporte que ATS da a las empresas que usan el sistema. NO es
      // el módulo de soporte de app.khipure.com, donde cada empresa atiende a
      // sus propios clientes.
      {
        path: 'support/tickets',
        loadComponent: () => import('./views/pages/support/support-inbox/support-inbox.component').then(m => m.OpsSupportInboxComponent)
      },
      {
        path: 'support/tickets/:id',
        loadComponent: () => import('./views/pages/support/support-ticket-detail/support-ticket-detail.component').then(m => m.OpsSupportTicketDetailComponent)
      },
      {
        // Catálogo de tipos de incidencia. Va despuÉs de `support/tickets/:id`
        // sin riesgo de colisión: el segmento es `categories`, no `tickets`.
        path: 'support/categories',
        loadComponent: () => import('./views/pages/support/support-categories/support-categories.component').then(m => m.OpsSupportCategoriesComponent)
      }
    ]
  },
  
  // Ruta por defecto
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
